/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  /**
   * "Abstract" base class from which other selectors views inherit.
   * Selectors must implement the interface described below.
   */
  ns.BaseSelectorView = Backbone.View.extend({
    /**
     * @interface properties
     */
    name: null, // Name of the data selector
    el: null, // jQuery selector for the element's container
    templateSelector: null, // jQuery selector to locate the underscore.js template
    propertyName: null, // The name of the model attribute which the data selector controls
    selectorInfoPropertyName: null, // property for the selector info array

    /**
     * @interface methods
     */
    /**
     * Updates the model with default selections, for cases where the user arrives
     * at the page with nothing preselected.
     */
    initializeModel: function() {
      throw "Not implemented. Please override in subclass.";
    },

    /**
     * Updates the DOM to match the selections specified on the model
     */
    updateDOM: function() {
      throw "Not implemented. Please override in subclass.";
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      throw "Not implemented. Please override in subclass.";
    },

    /**
     * OPTIONAL: Returns true if the model currently has a value set for the selector.
     * Default implementation is included in base class
     */
    //hasValueSet: function()

    //// Abstract class implementation ////

    initialize: function() {
      _.bindAll(this, "render");
    },

    render: function(selectorInfo) {
      // Verify this selector's container is present
      if (this.$el.length === 0) {
        throw "Could not find the " + this.name + " container: " + this.el;
      }

      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }

      // Re-render the control
      this.$el.html(this.template(selectorInfo));

      // If the model doesn't yet have the corresponding property set, choose a default now
      if (!this.hasValueSet() || !this.selectorHasValue(selectorInfo)) {
        this.initializeModel();
      }

      // Update the DOM to match the value currently on the model
      this.updateDOM();
    },

    selectorHasValue: function(selectorInfo) {
      if (!this.selectorInfoPropertyName) return true;

      var val = this.model.get(this.propertyName);
      var options = selectorInfo[this.selectorInfoPropertyName];
      //if any ids in options match val then return true, otherwise return false
      return _.some(options, function(v) {
        return v.id == val;
      });
    },

    hasValueSet: function() {
      var val;

      val = this.model.get(this.propertyName);

      if (val instanceof Array) {
        return !!val.length;
      }
      return !!this.model.get(this.propertyName);
    },

    defaultMultiSelectOptions: {
      selectedText: function(numChecked, numTotal, checkedItems) {
        var $item;

        if (numChecked > 1) {
          return numChecked + " of " + numTotal + " selected";
        }

        $item = $(checkedItems[0]);
        return $item.next().text();
      }
    }
  });
})(jQuery, _);
